module.exports = __webpack_public_path__ + "img/blog5.6e23c781.jpg";